import { toDate as o } from "./toDate.js";
function r(e) {
  const t = o(e);
  return t.setMilliseconds(0), t;
}
export {
  r as default,
  r as startOfSecond
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/startOfSecond.js
// module id = 455
// module chunks = 67